import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

export interface TimelineState {
  isActive: boolean;
  isLoading: boolean;
  isPlaying: boolean;
  currentYear: number;
}

@Injectable()
export class MapTimelineStateService {
  private stateSubject = new BehaviorSubject<TimelineState>({
    isActive: false,
    isLoading: false,
    isPlaying: false,
    currentYear: new Date().getFullYear(),
  });

  public state$: Observable<TimelineState> = this.stateSubject.asObservable();

  public getState(): TimelineState {
    return this.stateSubject.value;
  }

  public setActive(isActive: boolean): void {
    this.updateState({ isActive });
  }

  public setLoading(isLoading: boolean): void {
    this.updateState({ isLoading });
  }

  public setPlaying(isPlaying: boolean): void {
    this.updateState({ isPlaying });
  }

  public setYear(year: number): void {
    this.updateState({ currentYear: year });
  }

  public updateState(partial: Partial<TimelineState>): void {
    this.stateSubject.next({
      ...this.stateSubject.value,
      ...partial,
    });
  }

  public reset(): void {
    this.stateSubject.next({
      isActive: false,
      isLoading: false,
      isPlaying: false,
      currentYear: new Date().getFullYear(),
    });
  }
}
